export automaticSending from './automatic-sending/handlers';
export message from './message/handlers';
export emailTemplate from './template/handlers';
export emailPropertyData from './property-data/handlers';



// WEBPACK FOOTER //
// ./src/frontend/modules/email/handlers.js